export default {
  arenaAdverts: state => state.adverts,
  filter: state => state.filter,
  selectedBidCard: state => state.selectedBidCard,
  getArenaAdvertById: state => id => state.adverts.find(advert => advert.id === id),
  stockExchangeEmployerSearchOccupations: state => state.employerSearchOccupations,

  auctionId: state => state.auctionId,
  intervalFrom: state => state.intervalFrom,
  intervalTo: state => state.intervalTo,
  isSearchTriggered: state => state.isSearchTriggered
}



// WEBPACK FOOTER //
// ./src/store/modules/arena/getters.js